import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import _  from 'lodash';
import GridTooltip from '../../portal/gridTooltip';

@inject('teamsStore', 'translationsStore') @observer
export default class TeamsTooltipContainer extends Component {

    render() {

        let teams = [];

        this.props.teamIds.forEach(id => {
            
            this.props.teamsStore.teams.forEach(team => {
               
                if (team.id === id) {
                    
                    teams.push(team)
                }
            });            
        });

        const topTeam = _.minBy(teams, (o) => o.parentId);

        let teamCount = null;

        if (teams.length > 1) {

            teamCount = <GridTooltip
                            translations={{
                                title: this.props.translationsStore.translate('TEAMS')
                            }}
                            count={this.props.teamIds.length}
                            defaultName={topTeam.name}
                            itemId={this.props.itemId}
                            items={teams}
                        />
        }
        else {

            teamCount = <span
                            className='ellipsis'
                            title={topTeam.name}
                        >
                            {topTeam.name}
                        </span>;
        }

        return teamCount;
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/teamListTooltip/index.jsx